import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/infopages.scss";

function Terms() {
  return (
    <div className="terms">
      <Header />
      <main id="maincontent" className="page-main">
        <div className="page-title-wrapper">
          <h1 className="page-title"><span className="base">Terms &amp; Conditions</span></h1>
        </div>
        <div className="columns"><div className="column main">
          <p>Last updated: 8 September 2026</p>
          <p>These terms apply when you use hetcratehub.today or purchase from hetcratehub. By using the site, you agree to these terms and the policies linked from it.</p>

          <h4>1. Using the website</h4>
          <p>You may use the site for lawful personal shopping. You must not interfere with its operation, attempt unauthorised access, misuse another person's details, scrape the site at unreasonable volume, or use the content in a misleading or unlawful way.</p>

          <h4>2. Product information</h4>
          <p>We aim to describe products accurately. Colours and packaging may appear different on a screen, and manufacturers may update ingredients or presentation. Always check the physical product label before use, especially for allergies, feeding directions, and safety information.</p>

          <h4>3. Prices and orders</h4>
          <p>Prices and availability may change before an order is accepted. Placing an order is an offer to buy. We may decline or cancel an order for reasons including stock errors, suspected fraud, payment failure, an obvious pricing error, or delivery restrictions. If payment has already been taken for a cancelled order, it will be returned using the original payment method.</p>

          <h4>4. Payment</h4>
          <p>Available payment methods are shown at checkout. Payment providers may perform authorisation and fraud checks. You confirm that you are authorised to use the selected payment method and that the submitted billing information is accurate.</p>

          <h4>5. Delivery</h4>
          <p>Delivery estimates are not guarantees unless expressly stated. Risk and ownership pass as required by applicable consumer law and the agreed delivery terms. Review the <a href="/shipping">Shipping Information</a> page for current service details.</p>

          <h4>6. Returns and refunds</h4>
          <p>Returns are governed by our <a href="/returns">Returns &amp; Exchanges</a> policy and any mandatory consumer rights. Certain opened food, personalised, perishable, or hygiene-sensitive items may be ineligible except where faulty or otherwise required by law.</p>

          <h4>7. Pet health information</h4>
          <p>Site content is general information and is not veterinary advice. Consult a qualified veterinarian about illness, injury, allergies, medication, or significant diet changes. In an emergency, contact an emergency veterinary service immediately.</p>

          <h4>8. Intellectual property</h4>
          <p>The hetcratehub name, visual identity, original product imagery, page copy, and site design are protected by applicable intellectual-property laws. You may view the site for personal use, but may not reproduce or commercially exploit protected material without permission. Third-party rights remain with their respective owners.</p>

          <h4>9. Third-party services</h4>
          <p>The site may rely on or link to third-party payment, delivery, or technical services. Their own terms and privacy notices may apply. A link does not imply ownership or endorsement.</p>

          <h4>10. Liability</h4>
          <p>Nothing in these terms excludes liability that cannot lawfully be excluded. Subject to that rule, we are not responsible for indirect or unforeseeable loss, or loss caused by events reasonably outside our control. The site is provided on an as-available basis.</p>

          <h4>11. Privacy and cookies</h4>
          <p>Our handling of personal information is explained in the <a href="/privacy">Privacy Policy</a>. Browser storage and tracking choices are explained in the <a href="/cookies">Cookie Policy</a>.</p>

          <h4>12. Changes and severability</h4>
          <p>We may update these terms prospectively. If one provision is found unenforceable, the remaining provisions continue to apply. No delay in enforcing a right waives that right.</p>

          <h4>13. Contact</h4>
          <p>Questions about these terms may be sent to <a href="mailto:group@hetcratehub.today">group@hetcratehub.today</a> or mailed to 23 Wharf Street, London, England, SE8 3GG UK.</p>
        </div></div>
      </main>
      <Footer />
    </div>
  );
}

export default Terms;
